export default "__VITE_ASSET__BxiXB7uw__"